import {Validation} from "vuelidate";


export function getValidationMessages(validation: Validation){
  const messages: string[] = [];

  let failedValidators = Object.keys(validation).filter(
    e =>  !e.startsWith('$') && (<any>validation)[e] === false
  );
  // console.log('failed validators:', failedValidators)

  failedValidators.map(v => {
    let message ;
    const p = validation.$params;
    // console.log('validation error type: ', v);

    switch (v) {
      case 'between':
        message = "Entry must be between " + p[v].min + " and " + p[v].max;
        break;
      case 'required':
        message = "This field is required.";
        break;
      case 'requiredIfCrackingExists':
        message = 'An estimate of cracking extent is required if alligator cracking is present. Value must be between 0 and 100.';
        break;
      case 'sameAs':
        message = 'Make sure both values are the same.';
        break;
      case 'minValue':
        message = 'Must be >' + p[v].min;
        break;
      case 'maxValue':
        message = 'Must be <' + p[v].max;
        break;
      case 'minLength':
        message = 'This input is shorter than the minimum allowed length.';
        break;
      case 'maxLength':
        message = 'This input is longer than the maximum allowed length.';
        break;
      case 'email':
        message = 'Please enter a valid email address.';
        break;
      default:
        console.log("Unhandled validation error: " + v);
        message = "Validation error: " + JSON.stringify(v);
    }
    messages.push(message)
  });

  let finalMessage = '';
  messages.map(m => finalMessage += '\n' + m);
  // console.log("messages", messages);
  return finalMessage
}
